import {configureStore} from '@reduxjs/toolkit'
import {api} from "./middleware/api";
import cart from "./cart"
import product from "./Products"
import categories from "./Categories"
import orders from "./Orders"
import user from "./User"


export default configureStore({
    reducer: {
        cart, product, categories, orders, user
    },
    middleware: [
        api,
    ]
})